const Aboutus = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
      <defs>
        <clipPath id="a">
          <rect
            width="18"
            height="18"
            transform="translate(0.091)"
            fill="#fff"
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g transform="translate(636 -4430)">
        <g transform="translate(-636.091 4430)">
          <g transform="translate(0 1.527)">
            <g transform="translate(0 6.537)">
              <path
                d="M15.363,231.033H13.6a2.63,2.63,0,0,0-.693.093,2.639,2.639,0,0,0-2.351-1.446H7.443a2.639,2.639,0,0,0-2.351,1.446,2.63,2.63,0,0,0-.693-.093H2.637A2.64,2.64,0,0,0,0,233.669v2.817a1.584,1.584,0,0,0,1.582,1.582H16.418A1.584,1.584,0,0,0,18,236.486v-2.817A2.64,2.64,0,0,0,15.363,231.033ZM4.806,232.317v4.7H1.582a.528.528,0,0,1-.527-.527v-2.817a1.584,1.584,0,0,1,1.582-1.582H4.4a1.577,1.577,0,0,1,.414.055C4.809,232.2,4.806,232.258,4.806,232.317Zm7.333,4.7H5.861v-4.7a1.584,1.584,0,0,1,1.582-1.582h3.114a1.584,1.584,0,0,1,1.582,1.582Zm4.806-.527a.528.528,0,0,1-.527.527H13.194v-4.7c0-.059,0-.117-.006-.174a1.579,1.579,0,0,1,.414-.055h1.762a1.584,1.584,0,0,1,1.582,1.582Z"
                transform="translate(0 -229.68)"
              />
            </g>
            <g transform="translate(1.175 2.91)">
              <path
                d="M35.757,126.5a2.343,2.343,0,1,0,2.343,2.343A2.346,2.346,0,0,0,35.757,126.5Zm0,3.631a1.288,1.288,0,1,1,1.288-1.288A1.29,1.29,0,0,1,35.757,130.135Z"
                transform="translate(-33.414 -126.504)"
              />
            </g>
            <g transform="translate(5.87)">
              <path
                d="M170.092,43.729a3.13,3.13,0,1,0,3.13,3.13A3.134,3.134,0,0,0,170.092,43.729Zm0,5.206a2.076,2.076,0,1,1,2.076-2.076A2.078,2.078,0,0,1,170.092,48.935Z"
                transform="translate(-166.962 -43.729)"
              />
            </g>
            <g transform="translate(12.139 2.91)">
              <path
                d="M347.637,126.5a2.343,2.343,0,1,0,2.343,2.343A2.346,2.346,0,0,0,347.637,126.5Zm0,3.631a1.288,1.288,0,1,1,1.288-1.288A1.29,1.29,0,0,1,347.637,130.135Z"
                transform="translate(-345.294 -126.504)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Aboutus;
